import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LazyMotion } from 'framer-motion';

import {
  Footer,
  Header,
} from './Layout';
import { FooterCTA, VideoModal } from './Page';
import { VideoModalProvider, VideoModalContext } from '../context/VideoModalContext';

import '../styles/base.css';
import '../styles/fluid.css';
import '../styles/extend.css';

const loadFeatures = () =>
  import('../helpers/framer-features.js').then(res => res.default);

const LayoutContent = ({ children, location }) => {
  const { showModal, watchVideo, closeVideoModal } = React.useContext(VideoModalContext);

  // Close modal when user navigates to a different page
  useEffect(() => {
    closeVideoModal();
  }, [location.pathname, closeVideoModal]);

  return (
    <LazyMotion strict features={loadFeatures}>
      {watchVideo?.data?.embed?.html && (
        <VideoModal
          watchVideo={watchVideo}
          showModal={showModal}
          modalOpenState={closeVideoModal}
        />
      )}
      <header id="header" className="sticky top-0 z-50">
        <Header />
      </header>
      <main id="main">
        {children}
      </main>
      <FooterCTA />
      <footer id="footer" className="bg-gray-50" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <Footer />
      </footer>
    </LazyMotion>
  );
};

const Layout = ({ children, location }) => {
  return (
    <VideoModalProvider>
      <LayoutContent children={children} location={location} />
    </VideoModalProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    href: PropTypes.string,
  }).isRequired,
};

export default Layout;
